import React, { useState } from 'react';
import { ContentContainer } from '@libComponents';
import AppliedLeaves from './AppliedLeaves';
import RemainingLeaves from './RemainingLeaves';
import { theme } from 'app/Theme';
import { Box, styled } from '@mui/material';
import YearPicker from '../YearPicker';
import dayjs from 'dayjs';

const StyledInputWrapper = styled(Box)(({ theme: { spacing } }) => ({
    width: '150px',
    marginLeft: 'auto',
    marginRight: '20px'
}));

function LeaveDetails() {
    const [year, setYear] = useState(new Date().getFullYear());

    const handleYearChange = (value) => {
        setYear(dayjs(value).year());
    };

    return (
        <ContentContainer
            title="Leaves Details"
            headerBg={theme.palette.background.mainHeader}
            AdornmentComponent={
                <StyledInputWrapper>
                    <YearPicker
                        onChange={handleYearChange}
                        value={year.toString()}
                    />
                </StyledInputWrapper>
            }
        >
            <Box sx={{ m: 3, mb: 0 }}>
                <RemainingLeaves year={year} />
                <AppliedLeaves year={year} />
            </Box>
        </ContentContainer>
    )
}

export default LeaveDetails
